<template>
  <div>
    <input ref="excel-upload-input" class="excel-upload-input" type="file" accept=".xlsx, .xls" @change="handleClick">
    <div class="drop" @drop="handleDrop" @dragover="handleDragover" @dragenter="handleDragover">
      <template v-if="!selectedFile">
        Drop excel file here or
        <el-button :loading="loading" style="margin-left:16px;" size="mini" type="primary" @click="handleUpload">
          Browse
        </el-button>
      </template>
      <template v-else>
        <div class="file-info">
          <div class="file-info-content">
            <img src="@/assets/imgs/Excel.png" alt="">
            <span class="file-name">{{ selectedFile.name }}</span>
            <div class="file-actions">
              <el-button type="text" icon="el-icon-delete" @click="removeFile" title="删除"></el-button>
              <el-button type="text" icon="el-icon-refresh" @click="handleUpload" title="重选"></el-button>
            </div>
          </div>

        </div>
      </template>
    </div>
  </div>
</template>

<script>
// 此组件现在直接将Excel文件传递给后端，不再在前端解析Excel内容
// 用户可以通过拖放或点击浏览按钮上传Excel文件，上传后显示文件名并提供删除和重选选项
import XLSX from 'xlsx'

export default {
  props: {
    beforeUpload: Function, // eslint-disable-line
    onSuccess: Function// eslint-disable-line
  },
  data () {
    return {
      loading: false,
      selectedFile: null,
      excelData: {
        header: null,
        results: null
      }
    }
  },
  methods: {
    generateData ({ header, results }) {
      this.excelData.header = header
      this.excelData.results = results
      this.onSuccess && this.onSuccess(this.excelData)
    },
    handleDrop (e) {
      e.stopPropagation()
      e.preventDefault()
      if (this.loading) return
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$message.error('Only support uploading one file!')
        return
      }
      const rawFile = files[0] // only use files[0]

      if (!this.isExcel(rawFile)) {
        this.$message.error('Only supports upload .xlsx, .xls suffix files')
        return false
      }
      this.upload(rawFile)
      e.stopPropagation()
      e.preventDefault()
    },
    handleDragover (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleUpload () {
      this.$refs['excel-upload-input'].click()
    },
    handleClick (e) {
      const files = e.target.files
      const rawFile = files[0] // only use files[0]
      if (!rawFile) return
      this.upload(rawFile)
    },
    upload (rawFile) {
      this.$refs['excel-upload-input'].value = null // fix can't select the same excel
      this.selectedFile = rawFile
      this.loading = true

      if (!this.beforeUpload) {
        this.onSuccess && this.onSuccess(rawFile)
        this.loading = false
        return
      }
      const before = this.beforeUpload(rawFile)
      if (before) {
        this.onSuccess && this.onSuccess(rawFile)
        this.loading = false
      }
    },
    removeFile () {
      this.selectedFile = null
      this.excelData = {
        header: null,
        results: null
      }
      this.onSuccess && this.onSuccess(null)
    },
    getHeaderRow (sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    isExcel (file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    readerData (rawFile) {
      this.loading = true
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = XLSX.utils.sheet_to_json(worksheet)
          this.generateData({ header, results })
          this.loading = false
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    }
  }
}
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed #bbb;
  /* width: 600px; */
  height: 160px;
  /* line-height: 160px; */
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}

.file-info {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .file-info-content {
    display: flex;
    align-items: center;
    justify-content: center;

    .file-name {
      font-size: 18px;
      margin: 10px 0;
      word-break: break-all;
      color: #606266;
    }
  }
}

.file-actions .el-button {
  font-size: 20px;
  margin: 0 5px;
}
</style>
